export { default } from './AuthenticationStackNavigator';
export * from './AuthenticationStackNavigator';
